/* eslint-disable no-magic-numbers, no-underscore-dangle, max-statements */
import L from 'leaflet';
import _ from 'lodash';

import { isBoundsInsideArea, findAreaByPoint, getSquareFromOffset, getSquareFromLatLng } from '../../../../../helpers/leaflet-helpers';

export default {
  template: '<div></div>',
  props: {
    map: null,
    bounds: null,
    show: false,
    zoomMax: null,
    zoom: null,
    currentArea: null,
    visiblePicAreas: Array,
    referencePoint: null,
    picCoordSize: null,
  },
  data() {
    return {
      grid: {},
      currentSquare: null,
    };
  },
  methods: {
    _selectBox(e) {
      const boxArea = findAreaByPoint(e.target._bounds.getCenter(), this.visiblePicAreas);

      if (boxArea) {
        this.$store.dispatch('selectPic', {
          offset: this.currentSquare.offset,
          bounds: e.target._bounds,
          areaId: boxArea.areaId,
          projectId: boxArea.projectId,
          sideLength: 1,
        });
      }
    },
    _drawGrid(size, area) {
      const maxLatOffset = this.currentSquare.offset.latOffset + size;
      const maxLngOffset = this.currentSquare.offset.lngOffset + size;

      let latOffset = this.currentSquare.offset.latOffset - size;
      let lngOffset = this.currentSquare.offset.lngOffset - size;

      const nextSquare = () => {
        if (latOffset === maxLatOffset) {
          latOffset = this.currentSquare.offset.latOffset - size;
          lngOffset++;
        } else {
          latOffset++;
        }
      };

      const getLineOpacity = (absoluteLatOffset, absoluteLngOffset) => {
        const relativeLatOffset = absoluteLatOffset - this.currentSquare.offset.latOffset;
        const relativeLngOffset = absoluteLngOffset - this.currentSquare.offset.lngOffset;

        return 1 - (Math.sqrt(relativeLatOffset * relativeLatOffset + relativeLngOffset * relativeLngOffset) / (size));
      };

      const newLines = [];

      while (lngOffset < maxLngOffset + 1) {
        newLines.push(`${latOffset},${lngOffset}`);
        nextSquare();
      }

      newLines.forEach(key => {
        if (!this.grid[key]) {
          const offset = key.split(',');
          const lineSquare = getSquareFromOffset(
            Number(offset[0]), Number(offset[1]), area.refPoint, area.picCoordSize
          );

          if (isBoundsInsideArea(lineSquare.bounds, this.visiblePicAreas)) {
            this.grid[key] = L.rectangle(lineSquare.bounds, { fillOpacity: 0 }).addTo(this.map);
          }
        }
      });

      Object.keys(this.grid).forEach(key => {
        if (newLines.indexOf(key) === -1) {
          this.map.removeLayer(this.grid[key]);
          delete this.grid[key];
        } else {
          const offset = key.split(',');
          const opacity = getLineOpacity(Number(offset[0]), Number(offset[1]));
          this.grid[key].setStyle({ opacity });
        }
      });
    },
    _cleanGrid() {
      Object.keys(this.grid).forEach(key => {
        this.map.removeLayer(this.grid[key]);
        delete this.grid[key];
      });
    },
    _cleanSquare() {
      if (this.currentSquare) {
        this.map.removeLayer(this.currentSquare.shape);
        this.currentSquare = null;
      }
    },
    drawHighlightedSquare(event) {
      if (this.show) {
        const pointArea = findAreaByPoint(event.latlng, this.visiblePicAreas);

        if (!pointArea) return;

        const square = getSquareFromLatLng(event.latlng, pointArea.refPoint, pointArea.picCoordSize);

        if (this.currentSquare && JSON.stringify(square.offset) !== JSON.stringify(this.currentSquare.offset)) {
          this._cleanSquare();
        }

        if (!this.currentSquare) {
          if (isBoundsInsideArea(square.bounds, this.visiblePicAreas)) {
            this.currentSquare = square;
            this.currentSquare.shape = L.rectangle(square.bounds, {
              weight: 1,
              color: '#60bae3',
              fillOpacity: 1,
            }).on('click', this._selectBox).addTo(this.map);

            this._drawGrid(10, pointArea);
          } else {
            this._cleanGrid();
          }
        }
      } else {
        this._cleanGrid();
        this._cleanSquare();
      }
    },
  },
  watch: {
    map(newValue, oldValue) {
      if (newValue !== oldValue) {
        const throttledDraw = _.throttle(this.drawHighlightedSquare, 20);
        this.map.on('mouseover', () => {
          this.map.on('mousemove', event => {
            throttledDraw(event);
          });
        });
        this.map.on('mouseout', () => {
          this.map.off('mousemove');
          this._cleanSquare();
          this._cleanGrid();
        });
      }
    },
    show(value) {
      if (!value) {
        this._cleanSquare();
        this._cleanGrid();
      }
    },
  },
};
